import { render, staticRenderFns } from "./performance-description-header.component.vue?vue&type=template&id=78355a60&scoped=true&"
import script from "./performance-description-header.component.vue?vue&type=script&lang=ts&"
export * from "./performance-description-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./performance-description-header.component.vue?vue&type=style&index=0&id=78355a60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78355a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VRow,VTextarea})
